export default __webpack_public_path__ + "static/media/value2.7751bc0e.png";